import { H, Grid } from '@farewill/ui'
import { useFormikContext } from 'formik'

import { FuneralBrandId } from 'config/brands'
import { FuneralAttributes } from 'lib/models/funeral'
import FuneralCremation from './funeral-cremation/funeral-cremation'
import { FormikValues, SaveProp } from './types'

const Funeral = ({
  handleSave,
  saveFuneralFields,
}: {
  handleSave: SaveProp
  saveFuneralFields: (attributes: FuneralAttributes) => void
}) => {
  const { values } = useFormikContext()
  const contact = (values as FuneralAttributes).contact

  /** Unlikely to happen, if it does let's know about it */
  if (!contact) {
    throw new Error('Funeral contact is required for fact-find')
  }

  return (
    <Grid>
      <Grid.Item>
        <H size="M">5. The funeral</H>
      </Grid.Item>

      <FuneralCremation
        brandId={contact.brandId as FuneralBrandId}
        handleSave={handleSave}
        values={values as FormikValues}
        saveFuneralFields={saveFuneralFields}
      />
    </Grid>
  )
}

export default Funeral
